// 이미지 업로드/삭제. glove-server 의 image/upload, image/delete 프록시 호출.
// 기존 aws-sdk 직접 업로드(/get_param credential) 대체. 응답 shape({ Location, Key, Bucket, ETag })은 동일.
// 두 엔드포인트는 EXCEPT_ROUTE (비로그인 카트 업로드 허용), 검증은 server-side.

import _Fetch from './Fetches';
import { SERVER_URL } from './Settings';

const UPLOAD_API = {
  url: `${SERVER_URL}/gloveworks/restapi/image/upload`,
  method: 'POST',
};
const DELETE_API = {
  url: `${SERVER_URL}/gloveworks/restapi/image/delete`,
  method: 'POST',
};

/**
 * @param {string} file  data URI 형식 ("data:image/png;base64,...")
 * @param {string} path  S3 path prefix ('customize' | 'customize/logos' | 'customize/addon' | 'admin')
 * @returns {Promise<{Location: string, Key: string, Bucket: string, ETag?: string}>}
 */
export const UploadImage = async (file, path = 'customize') => {
  // _Fetch 의 _postFetch 는 server 의 returnSuccess 응답을 double-parse 한 뒤 data.results 로 resolve.
  // 우리 server endpoint(rest_image.js) 가 returnSuccess(S3.upload 결과) 를 보내므로
  // 여기서 받는 값은 { Location, Key, Bucket, ETag } 객체 그대로.
  return _Fetch(UPLOAD_API, '', { image: file, path });
};

/**
 * @param {string} key  S3 object key (e.g. "customize/abc.png")
 */
export const DeleteData = async (key) => {
  if (!key) return false;
  try {
    return await _Fetch(DELETE_API, '', { key });
  } catch (e) {
    console.error('DeleteData failed', e);
    return false;
  }
};
